
export const isMobile = function () {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export const isIOS = function () {
  return navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i)
}

export const isWechat = function () {
  return navigator.userAgent.match(/micromessenger/i)
}
